import { createAsyncThunk } from '@reduxjs/toolkit'
import { TablePaginationConfig } from 'antd'

import { env } from '@/common/config/env'
import { HttpMethods } from '@/common/constants/http-methods.constants'
import api from '@/common/helpers/api.helpers'

import {
  IStripeTerminalCreate,
  IStripeTerminalUpdate,
  IStripeTerminalMediaUpload,
} from 'src/features/stripe-terminals/interfaces/stripe-terminal.interface'

const baseUrl = `${env.RESIDEN_API_BASE_URL}/stripe-terminal`

const fetchStripeTerminals = createAsyncThunk('stripeTerminals/fetchStripeTerminals', async () => {
  const response = await api(HttpMethods.GET, `${baseUrl}`)
  return response.data
})

const fetchStripeTerminal = createAsyncThunk('stripeTerminals/fetchStripeTerminal', async (id: number) => {
  const response = await api(HttpMethods.GET, `${baseUrl}/${id}`)
  return response.data
})

const createStripeTerminal = createAsyncThunk(
  'stripeTerminals/createStripeTerminal',
  async (data: IStripeTerminalCreate) => {
    const response = await api(HttpMethods.POST, baseUrl, data)
    return response.data
  },
)

const updateStripeTerminal = createAsyncThunk(
  'stripeTerminals/updateStripeTerminal',
  async ({ id, data }: { id: number; data: IStripeTerminalUpdate }) => {
    const response = await api(HttpMethods.PUT, `${baseUrl}/${id}`, data)
    return response.data
  },
)

const deleteStripeTerminal = createAsyncThunk('stripeTerminals/deleteStripeTerminal', async (id: number) => {
  const response = await api(HttpMethods.DELETE, `${baseUrl}/${id}`)
  return response.data
})

const uploadStripeTerminalMedia = createAsyncThunk(
  'stripeTerminals/uploadStripeTerminalMedia',
  async ({ id, data }: { id: number; data: IStripeTerminalMediaUpload }) => {
    const formData = new FormData()
    formData.append('file', data.file)
    formData.append('type', data.type)

    const response = await api(HttpMethods.POST, `${baseUrl}/media/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  },
)

const deleteStripeTerminalMedia = createAsyncThunk('stripeTerminals/deleteStripeTerminalMedia', async (id: number) => {
  const response = await api(HttpMethods.DELETE, `${baseUrl}/media/${id}`)
  return response.data
})

export const stripeTerminalsService = {
  fetchStripeTerminals,
  fetchStripeTerminal,
  createStripeTerminal,
  updateStripeTerminal,
  deleteStripeTerminal,
  uploadStripeTerminalMedia,
  deleteStripeTerminalMedia,
}
